import { Controller } from 'stimulus';
import axios from 'axios';

class ArticleController extends Controller {
  connect() {
    this.API_URL = this.data.get('api');
    this.NEXT_PAGE = 2;
    this.CATEGORIES = [];
  }

  onPaginateClick({ currentTarget }) {
    this.NEXT_PAGE = parseInt(currentTarget.dataset.nextPage, 10);

    this.fetch();
  }

  onFilterClick({ currentTarget }) {
    const id = parseInt(currentTarget.dataset.filterId, 10);
    const index = this.CATEGORIES.indexOf(id);

    if (index > -1) {
      currentTarget.classList.remove('is-active');
      this.CATEGORIES.splice(index, 1);
    } else {
      currentTarget.classList.add('is-active');
      this.CATEGORIES.push(id);
    }

    this.NEXT_PAGE = 1;
    this.fetch(false);
  }

  async fetch(appendArticles = true) {
    try {
      const queryString = `?page=${this.NEXT_PAGE}&categories[]=${this.CATEGORIES}`;
      const { data } = await axios.get(`${this.API_URL}${queryString}`);
      const articles = await ArticleController.extractArticlesFromResponse(data);
      const pagination = await ArticleController.extractPaginationFromResponse(data);

      this.updateArticles(articles, appendArticles);
      this.updatePagination(pagination);
    } catch (error) {
      // console.error(error);
    }
  }

  updateArticles(articles, append = true) {
    if (append) {
      $(this.articlesTarget).append(articles.innerHTML);

      return;
    }

    $(this.articlesTarget).html(articles.innerHTML);
  }

  updatePagination(pagination) {
    $(this.paginationTarget).html(pagination.innerHTML);
  }

  static extractArticlesFromResponse(response) {
    const articles = $(response).find('[data-target="article.articles"]');

    if (!articles.length) return null;

    return articles[0];
  }

  static extractPaginationFromResponse(response) {
    const pagination = $(response).find('[data-target="article.pagination"]');

    if (!pagination.length) return null;

    return pagination[0];
  }
}

ArticleController.targets = [
  'articles',
  'pagination',
];

export default ArticleController;
